import React, { useEffect, useState, useRef } from 'react'
import { Subtitles } from './Subtitles'

const Tutor = (props) => {
  const {
    ttsData,
    tutorialStart,
    onTutorialComplete,
    showCC,
    getTutorTalking,
    currentOSName,
    muteStatus,
    newlyOpenedActivity,
    proceedClicked
    // speechApi
  } = props
  const [lineNumber, setLineNumber] = useState(-1)
  const [speechDataArray, setSpeechDataArray] = useState([])
  const [tutorTalking, setTutorTalking] = useState(false)
  const [showTutorial, setShowTutorial] = useState(false)
  const [isIntroPlaying, setIsIntroPlaying] = useState(false)
  const isSkipped = useRef(false)
  const [displaySubtitle, setDisplaySubtitle] = useState(false)
  const [completedAllCompData, setCompletedAllCompData] = useState([])
  const [displayPreoceedMessage, setDisplayPreoceedMessage] = useState(false)
  const [startTheSpeech, setStartTheSpeech] = useState(false)
  //Start the first line of introduction

  useEffect(() => {
    if (tutorialStart && ttsData && ttsData.length > 0) {
      setDisplayPreoceedMessage(false)
      setLineNumber(0)
      setSpeechDataArray(ttsData)
    }
  }, [tutorialStart])

  useEffect(() => {
    if (newlyOpenedActivity) {
      setShowTutorial(true)
    }
  }, [newlyOpenedActivity])

  useEffect(() => {
    if (lineNumber >= 0) {
      if (speechDataArray[lineNumber] && speechDataArray[lineNumber] !== '') {
        let completedTextData = [...completedAllCompData]
        setIsIntroPlaying(true)
        setShowTutorial(true)
        setDisplaySubtitle(true)
        speakBackground(speechDataArray[lineNumber])
        completedTextData.push(speechDataArray[lineNumber])
        setCompletedAllCompData(completedTextData)
      } else if (speechDataArray[lineNumber] === '') {
        setTimeout(() => {
          finishActions()
        }, 1000)
      } else if (!speechDataArray[lineNumber]) {
        setIsIntroPlaying(false)
        setLineNumber(ttsData.length)
        setShowTutorial(false)
        onTutorialComplete()
      }
    }
  }, [lineNumber])

  const startActions = () => {
    isSkipped.current = false
  }

  const finishActions = () => {
    setTutorTalking(true)
    setLineNumber((lineNumber) => lineNumber + 1)
  }

  function stopTutorial() {
    window.speechSynthesis.cancel()
    setLineNumber(ttsData.length)
    setShowTutorial(false)
    onTutorialComplete()
  }

  function configureSpeech(
    text,
    voiceURI,
    volume = 1,
    rate = 0.8,
    pitch = 0.9
  ) {
    const speechApi = new SpeechSynthesisUtterance()
    const voices = window.speechSynthesis.getVoices()
    speechApi.voice =
      voices.find((voice) => voice.voiceURI === voiceURI) || voices[0] // Fallback to first voice
    speechApi.volume = volume
    speechApi.rate = rate
    speechApi.pitch = pitch
    speechApi.text = text
    speechApi.lang = 'en-US'
    return speechApi
  }

  function speakBackground(text) {
    // Ensure voices are loaded
    if (!window.speechSynthesis.getVoices().length) {
      console.error('Voices not loaded yet')
      return
    }

    // Cancel ongoing speech
    if (window.speechSynthesis.speaking || window.speechSynthesis.pending) {
      window.speechSynthesis.cancel()
    }

    setTimeout(() => {
      startActions()
      const voiceURI =
        currentOSName === 'Chrome OS'
          ? 'Chrome OS US English 8'
          : 'Google US English'
      const volume = muteStatus ? 0 : 1
      const speechApi = configureSpeech(text, voiceURI, volume)

      speechApi.onend = () => {
        if (!isSkipped.current) {
          finishActions()
        }
      }

      speechApi.onerror = (error) => {
        console.error('Speech error:', error)
      }

      // Start speaking
      window.speechSynthesis.speak(speechApi)
    }, 100)
  }

  useEffect(() => {
    if (isIntroPlaying) {
      getTutorTalking(false)
    } else {
      getTutorTalking(true)
    }
  }, [isIntroPlaying])

  if (showTutorial) {
    return (
      <span className='knovaBotSeqView'>
        {displaySubtitle || displayPreoceedMessage ? (
          <Subtitles
            isTutor={true}
            text={speechDataArray}
            lineNumber={lineNumber}
            showCC={showCC}
            botType={'tutor'}
            tutorTalking={isIntroPlaying}
            onFrwdSkipClick={() => {
              if (displayPreoceedMessage) {
                setStartTheSpeech(true)
              } else {
                isSkipped.current = true
                stopTutorial()
              }

              if (newlyOpenedActivity) {
                proceedClicked()
              }
            }}
            handleBotVolume={(isBotMute) => {
              // if (speechApi !== '') {
              //   if (isBotMute) {
              //     speechApi.volume = 0
              //   } else {
              //     speechApi.volume = 1
              //   }
              // }
            }}
            completedAllCompData={completedAllCompData}
            newlyOpenedActivity={displayPreoceedMessage}
          />
        ) : (
          <span />
        )}
      </span>
    )
  }

  return null
}

export { Tutor }
